import { RETAINER_ARCH_LABELS, RETAINER_ATTRIBUTES, RETAINER_CUT_TYPE_LABELS } from '../constants';
import {
  ASSIGNMENT_LABELS,
  ASSIGNMENTS,
  SCAN_SUBMISSION_LABELS,
  SCAN_SUBMISSION_METHODS,
  SCANNER_LABELS
} from '../../IDB/constants';

export default rxForm => {
  return [
    {
      attribute: RETAINER_ATTRIBUTES.DOCTOR,
      generateLabel: (value, data) => data.user.full_name
    },
    {
      attribute: RETAINER_ATTRIBUTES.CASE_NUMBER_TEXT
    },
    {
      attribute: RETAINER_ATTRIBUTES.ARCH_TYPE,
      generateLabel: value => RETAINER_ARCH_LABELS[value] || value
    },
    {
      attribute: RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE,
      generateLabel: value => RETAINER_CUT_TYPE_LABELS[value] || value
    },
    {
      attribute: RETAINER_ATTRIBUTES.SCAN_SUBMISSION_METHOD,
      generateLabel: (value, data) => {
        let label = SCAN_SUBMISSION_LABELS[value];
        if (value !== SCAN_SUBMISSION_METHODS.UPLOAD) {
          const scannerName =
            data[RETAINER_ATTRIBUTES.CUSTOM_SCANNER_NAME] ||
            SCANNER_LABELS[data[RETAINER_ATTRIBUTES.SCANNER]];
          label = `${label} (${scannerName})`;
        }
        return label.replace('{ASSIGNMENT}', ASSIGNMENT_LABELS[ASSIGNMENTS.ORTHOSELECT]);
      }
    },
    {
      attribute: RETAINER_ATTRIBUTES.SHIPPING_LOCATION,
      generateLabel: (value, data) => data.shipping_location && data.shipping_location.location_name
    },
    {
      attribute: RETAINER_ATTRIBUTES.SHIPPING_METHOD,
      generateLabel: (value, data) => data.shipping_method_label
    },
    {
      attribute: 'tracking_number',
      hide: !rxForm.tracking_number
    },
    {
      attribute: 'created_by_user_id',
      hide: rxForm.user_id === rxForm.created_by_user_id,
      generateLabel: (value, data) => data.created_by_user.full_name
    }
  ];
};
